<template>
	<v-dialog
			:content-class="`wrapperPopup ${customClass}`"
			:width="width"
			:value="true"
			:fullscreen="fullscreen"
			:hide-overlay="hideOverlay"
			:transition="transition"
	    :persistent="persistent"
	>
		<div :class="['wrapPopup', { allHeight: isAllHeight }]">
			<slot name="header">
				<div :style="`height: ${heightHead}`" class="popupHead">
					<span class="popupHead-title">{{ title }}</span>
					<button type="button" @click="onClosePopup">
						<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
					</button>
				</div>
			</slot>
			<slot name="top"></slot>
			<slot></slot>
			<slot v-if="!isHideBottom" name="bottom">
				<button-groups
						:apply-text="btnText"
						@updateBtnClose="onClosePopup"
						@updateSave="onSave"
						:is-btn-safe="isBtnSafe"
						:is-disabled="isDisabled"
				></button-groups>
			</slot>
		</div>
	</v-dialog>
</template>

<script>
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups.vue";

export default {
	name: "Popup",
	components: { ButtonGroups },
	props: {
		isAllHeight: {
			type: Boolean,
			default: () => false
		},
		isBtnSafe: {
			type: Boolean,
			default: () => false
		},
		isDisabled: {
			type: Boolean,
			default: () => false
		},
		isHideBottom: Boolean,
		customClass: String,
		heightHead: String,
		btnText: {
			type: String,
			default: () => "SAVE"
		},
		width: [ Number, String ],
		title: String,
		fullscreen: {
			type: Boolean,
			default: () => true
		},
		persistent: {
			type: Boolean,
			default: () => true
		},
		hideOverlay: {
			type: Boolean,
			default: () => false
		},
		contentClass: String,
		transition: {
			type: String,
			default: () => 'dialog-bottom-transition'
		}
	},
	methods: {
		onClosePopup() {
			this.$emit('updateClosePopup');
		},
		onSave() {
			this.$emit('updateSave');
		}
	}
};
</script>

<style lang="scss" scoped>
@import "Popup";
</style>

